import { inject, injectable } from '@servicetitan/react-ioc';
import { SettingsApi } from 'api';
import { action, makeObservable, observable } from 'mobx';

interface SpecialSettings {
    'permission-settings': PermissionSettings;
}
interface PermissionSettings {
    requireInviteToSignUp: boolean;
}

@injectable()
export class SettingsStore {
    @observable permissionSettings?: PermissionSettings;
    @observable loadingSettings: boolean = true;
    @observable failedToLoadSettings: boolean = false;

    constructor(@inject(SettingsApi) private settingsApi: SettingsApi) {
        makeObservable(this);
        this.loadPermissionSettings();
    }

    private async loadPermissionSettings() {
        try {
            const permissionSettings = await this.settingsApi.client.getAllSpecialSettings();
            this.setPermissionsSettingsFormValues(permissionSettings);
        } catch (e) {
            this.failedToLoadSettings = true;
        } finally {
            this.loadingSettings = false;
        }
    }

    @action
    private setPermissionsSettingsFormValues(rawPermissionSettings: any) {
        const specialSettings = this.normalizeSpecialSettings(rawPermissionSettings);

        const permissionSettings: PermissionSettings = {
            requireInviteToSignUp:
                specialSettings['permission-settings']?.requireInviteToSignUp ?? false,
        };
        this.permissionSettings = permissionSettings;
    }

    private normalizeSpecialSettings(rawFilter: any): SpecialSettings {
        if (typeof rawFilter === 'object' && rawFilter !== null) {
            return rawFilter as SpecialSettings;
        }
        return {} as SpecialSettings;
    }
}
